type IconProps = { icon: string; class?: string };

export function Icon(props: IconProps) {
	const tagString = props.icon;
	const range = document.createRange();

	range.selectNode(document.body);
	const documentFragment = range.createContextualFragment(tagString);
	const svg = documentFragment.children[0] as SVGElement;

	svg.style.pointerEvents = 'none';

	if (props.class) {
		svg.setAttribute('class', props.class);
	}

	return svg;
}
